import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";

export const RelevantFulfillmentGroupNotFoundReasonSchema = z.enum([
  "NOT_FOUND",
  "NO_ITEMS",
  "CANCELLED",
  "VOIDED",
  "CLOSED",
  "NO_DELIVERY_METHOD",
]);

export type RelevantFulfillmentGroupNotFoundReason = z.infer<
  typeof RelevantFulfillmentGroupNotFoundReasonSchema
>;

export const getRelevantFulfillmentGroupData = {
  name: "getRelevantFulfillmentGroupData" as const,
  input: z.object({ identifier: z.string() }),
  output: z.object({
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema),
    notFoundReason: RelevantFulfillmentGroupNotFoundReasonSchema.optional(),
  }),
};
